import { render } from "./EditModal.vue?vue&type=template&id=a3c5fb5e"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__